// KeyConceptQuote.js (สร้างไฟล์แยกก็ได้)
const QUOTES = [
    {
      th: "ทุกการเปลี่ยนแปลง เริ่มจาก 'การสังเกต' ว่าเวลาหายไปไหน",
      en: "Every transformation begins with simply noticing where your time goes.",
    },
    {
      th: "นิสัยเล็ก ๆ เปลี่ยนชีวิตได้จริง แค่เริ่มแล้วทำซ้ำ",
      en: "Tiny habits, repeated daily, will change your life.",
    },
    {
      th: "เวลาคือการลงทุนที่แท้จริง ไม่ใช่แค่เงิน",
      en: "Time is the real investment—not just money.",
    },
    {
      th: "อย่าแข่งขันกับใคร แค่เปรียบเทียบกับตัวเองเมื่อวาน",
      en: "Don’t compete with others, compare yourself to yesterday’s you.",
    },
    {
      th: "หมั่นทบทวนตัวเอง…คุณจะเห็นโอกาสใหม่เสมอ",
      en: "Frequent self-reflection brings new opportunities for growth.",
    },
    {
      th: "ใช้เวลากับสิ่งที่สร้างคุณค่า เช่น การเรียนรู้หรือดูแลสุขภาพ",
      en: "Spend time on what builds value—like learning or caring for your health.",
    },
    // เพิ่ม key concept ตามใจ
  ];
  
  export default function KeyConceptQuote({ lang = "th" }) {
    // สุ่ม quote ใหม่ทุก reload (หรือใช้ state ถ้าอยากเปลี่ยนทุกปุ่มกด)
    const random = Math.floor(Math.random() * QUOTES.length);
    const q = QUOTES[random];
    return (
      <div className="flex justify-center w-full my-3">
        <div className="bg-gradient-to-r from-indigo-50 to-yellow-50 shadow-lg rounded-2xl px-6 py-5 max-w-md w-full mx-auto text-center">
          <span className="block font-medium text-gray-700 text-base md:text-lg leading-relaxed">
            “{q[lang]}”
          </span>
          <span className="mt-1 text-xs text-gray-400">#SpendoraKeyConcept</span>
        </div>
      </div>
    );
  }